import { limitFill } from "@cloudinary/url-gen/actions/resize";
import { autoGravity } from "@cloudinary/url-gen/qualifiers/gravity";
import { Divider } from "styled-system/jsx";
import { Button, ButtonProps, Card, Text } from "@ttc3k/trekker";
import { type AssetImage, EnumEventAccessOperatorStatus } from "gql/generated";
import { useTranslation } from "react-i18next";
import { EventStatusIndicator, SelectableImage } from "shared/components";
import { formatDate, isLandscape } from "shared/utils";
import { css } from "styled-system/css";
import { Flex } from "styled-system/jsx";

type EventCardProps = {
  hero?: AssetImage;
  title: string;
  updatedDate: Date;
  status: EnumEventAccessOperatorStatus | null | undefined;
  actionButtonProps?: ButtonProps;
};

export const EventCard = ({
  hero,
  title,
  updatedDate,
  status = EnumEventAccessOperatorStatus.Draft,
  actionButtonProps,
}: EventCardProps) => {
  const { t } = useTranslation("events", {
    keyPrefix: "APP.CARD",
  });

  return (
    <Card.Surface
      boxShadow={"none"}
      borderTopWidth={"0"}
      borderLeftWidth={"0"}
      borderRightWidth={"0"}
      borderRadius={"0"}
    >
      <Card.Body
        py="150"
        px={"1px"}
        display="flex"
        flexDir="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Flex flexDir="row" alignItems="center" gap={250}>
          {/* New selectable image component ... currently set to disabled because we have no bulk actions */}
          <SelectableImage
            selected={false}
            onSelectionChange={(isSelected) => console.log(isSelected)}
            image={hero}
            imageStyleProps={{
              className: css({
                borderRadius: "full",
                objectFit: "cover",
                width: "60px",
                height: "60px",
              }),
            }}
            resize={
              isLandscape(hero)
                ? limitFill().height(60).gravity(autoGravity())
                : limitFill().width(60).gravity(autoGravity())
            }
            size="lg"
            visual="accent"
            disabled={true}
          />

          <Flex flexDir="column" gap="50">
            <Text color="text.dark" visual="bodySemiBold">
              {title}
            </Text>
            <Text color="text.light" visual="smallMedium">
              {t("UPDATED")}: {formatDate(updatedDate)}
            </Text>
          </Flex>
        </Flex>

        <Flex flexDir="row" alignItems="center" gap="200">
          <EventStatusIndicator status={status} />

          <Divider
            orientation={"vertical"}
            borderColor={"border.light"}
            h={"24px"}
          />

          <Button
            visual={"primary"}
            mode={"light"}
            size={"sm"}
            {...actionButtonProps}
          />
        </Flex>
      </Card.Body>
    </Card.Surface>
  );
};
